class Order {
    constructor({
        id,
        attributes: {
            name,
            words,
        },
    }) {
        this._id = id;
        this._name = name;
        this._words = words;
    }

    get id() {
        return this._id;
    }

    get name() {
        return this._name;
    }

    get words() {
        return this._words;
    }
}

export default Order;
